<template>
  <div>
    <p>Choisir les dimensions variables pour chaque unité.</p>

    <table>
      <thead>
        <tr>
          <th>Unité</th>
          <th>Longueur</th>
          <th>Largeur</th>
          <th>Hauteur</th>
          <th>Diamètre</th>
          <th>Densité</th>
          <th>Contenance</th>
          <th>Poids</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <dimensions-variables-unite
          v-for="(dimensionVariable, index) of dimensionsVariables"
          :key="index"
          :ligne="dimensionVariable"
          :index="index"
        />
        <td colspan="9">
          <button @click="addEmptyDimensionVariable">Ajouter une nouvelle unité</button>
        </td>
      </tbody>
    </table>

    <div class="flex-wrap-fJend-fAcenter">
      <p>
        <button @click='enregistreDimensionsVariables'>Enregistrer</button>
        <button @click='enregistreEtQuitte'>Valider</button>
        <button @click='quitte'>Annuler</button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DimensionsVariablesUnite from './atoms/DimensionsVariablesUnite.vue'

export default {
  components: {
    'dimensions-variables-unite': DimensionsVariablesUnite
  },
  computed: {
    ...mapGetters([
      'dimensionsVariables'
    ])
  },
  created: async function() {
    await this.setDimensionsVariables()
    await this.setUnitesAjoutables()
  },
  methods: {
    ...mapActions([
      'setDimensionsVariables',
      'setUnitesAjoutables',
      'enregistreDimensionsVariables',
      'addEmptyDimensionVariable'
    ]),
    async enregistreEtQuitte() {
      await this.enregistreDimensionsVariables()
      window.location.href = '/openweb/admin/admin_accueil'
    },
    quitte() {
      window.location.href = '/openweb/admin/admin_accueil'
    }
  }
}
</script>
